import request from '@/utils/request'

// 历史期号
export function tradeRecordList(data) {
    return request({
      url: '/admin/tradeRecord/list',
      method: 'post',
      data
    })
  }
  export function tradeTicketList(data) {
    return request({
      url: '/admin/tradeTicket/list',
      method: 'post',
      data
    })
  }
  export function tradeTicketUpdate(data) {
    return request({
      url: '/admin/tradeTicket/update',
      method: 'post',
      data
    })
  }
// 购买记录
export function tradeBuyRecordList(data) {
  return request({
    url: '/admin/tradeBuyRecord/list',
    method: 'post',
    data
  })
}
// 币种管理
export function list(data) {
  return request({
    url: '/admin/ticket/list',
    method: 'post',
    data
  })
}
export function save(data) {
  return request({
    url: '/admin/ticket/save',
    method: 'post',
    data
  })
}
export function update(data) {
  return request({
    url: '/admin/ticket/update',
    method: 'post',
    data
  })
}
export function tradeTicketDelete(data) {
  return request({
    url: '/admin/ticket/delete',
    method: 'post',
    data
  })
}
export function testRecordPage(data) {
  return request({
    url: '/admin/tradeRecord/testRecordPage',
    method: 'post',
    data
  })
}
export function ticketList(data) {
  return request({
    url: '/admin/tradeRecord/ticketList',
    method: 'post',
    data
  })
}
export function addTestRecord(data) {
  return request({
    url: '/admin/tradeRecord/addTestRecord',
    method: 'post',
    data
  })
}
export function delTestRecord(data) {
  return request({
    url: '/admin/tradeRecord/delTestRecord',
    method: 'post',
    data
  })
}